import React, { useState } from 'react';
import { crearCliente } from '../servicios/api'; // Asumo que crearemos esta función
import { normalizarIdentificacionFiscal, validarIdentificacionFiscal } from '../validarIdentificacionFiscal';

const CollapsibleSection = ({ title, children, sectionId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSection = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="collapsible-section border border-slate-700 rounded-md mb-2">
      <div className="collapsible-header bg-slate-800 p-3 cursor-pointer flex items-center gap-2 font-medium text-blue-400 hover:bg-slate-700" onClick={toggleSection}>
        <span className={`toggle-icon text-xs transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`}>▶</span>
        {title}
      </div>
      <div className={`collapsible-content ${isOpen ? 'block' : 'hidden'} p-4 border-t border-slate-700`}>
        {children}
      </div>
    </div>
  );
};

const ModalCrearCliente = ({ isOpen, onClose, onClienteCreado }) => {
  const [formData, setFormData] = useState({
    nif: '',
    nombre: '',
    direccion: '',
    codigo_postal: '',
    poblacion: '',
    provincia: '',
    pais: 'España',
    descuento_porcentaje: '',
    iban: '',
    bic: '',
    telefono: '',
    email: '',
    web: '',
    idioma: 'es',
    formato_numerico: 'es',
    notas: '',
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: name === 'nif' ? value.toUpperCase() : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nif || !formData.nombre) {
      setError('El NIF y el Nombre son campos obligatorios.');
      return;
    }
    if (!validarIdentificacionFiscal(formData.nif)) {
      setError('El NIF, NIE o CIF no es válido.');
      return;
    }
    setError('');
    try {
      const response = await crearCliente({
        ...formData,
        nif: normalizarIdentificacionFiscal(formData.nif),
      });
      if (response.exito && response.cliente) {
        alert(response.mensaje);
        if (onClienteCreado) {
          onClienteCreado(response.cliente);
        }
        onClose();
      } else {
        setError(response.mensaje || 'Ocurrió un error desconocido.');
      }
    } catch (error) {
      console.error("Error al crear cliente:", error);
      const errorMessage = error.response && error.response.data && error.response.data.mensaje
        ? error.response.data.mensaje
        : "Error al conectar con el servidor para crear el cliente.";
      setError(errorMessage);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4">
      <div className="form-container bg-slate-900 rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col overflow-hidden border border-slate-700">
        <div className="form-header bg-slate-800 p-4 border-b border-slate-700 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-white">Crear un nuevo Cliente</h2>
          <button onClick={onClose} className="close-btn text-gray-400 hover:text-white text-2xl leading-none">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="form-content p-6 overflow-y-auto">
          <div className="section mb-6">
            <h3 className="section-title text-blue-400 font-semibold mb-4">Datos de facturación</h3>
            <div className="form-row grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div className="form-col md:col-span-1">
                <label htmlFor="nif" className="block text-sm font-medium text-gray-300 mb-1">NIF</label>
                <input type="text" id="nif" name="nif" value={formData.nif} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" required />
              </div>
              <div className="form-col md:col-span-2">
                <label htmlFor="nombre" className="block text-sm font-medium text-gray-300 mb-1">Nombre o razón social</label>
                <input type="text" id="nombre" name="nombre" value={formData.nombre} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" required />
              </div>
            </div>
          </div>

          <div className="section mb-6">
            <h3 className="section-title text-blue-400 font-semibold mb-4">Dirección</h3>
            <div className="form-group mb-4">
              <label htmlFor="direccion" className="block text-sm font-medium text-gray-300 mb-1">Dirección</label>
              <input type="text" id="direccion" name="direccion" value={formData.direccion} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
            </div>
            <div className="form-row grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div className="form-col">
                <label htmlFor="codigo_postal" className="block text-sm font-medium text-gray-300 mb-1">Código Postal</label>
                <input type="text" id="codigo_postal" name="codigo_postal" value={formData.codigo_postal} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
              </div>
              <div className="form-col">
                <label htmlFor="poblacion" className="block text-sm font-medium text-gray-300 mb-1">Población</label>
                <input type="text" id="poblacion" name="poblacion" value={formData.poblacion} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
              </div>
            </div>
            <div className="form-row grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div className="form-col">
                <label htmlFor="provincia" className="block text-sm font-medium text-gray-300 mb-1">Provincia</label>
                <input type="text" id="provincia" name="provincia" value={formData.provincia} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
              </div>
              <div className="form-col">
                <label htmlFor="pais" className="block text-sm font-medium text-gray-300 mb-1">País</label>
                <select id="pais" name="pais" value={formData.pais} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500">
                  <option value="España">España</option>
                  <option value="Francia">Francia</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Italia">Italia</option>
                </select>
              </div>
            </div>
            <button type="button" onClick={() => alert('Mostrando dirección en el mapa...')} className="map-btn bg-blue-600 text-white py-2 px-4 rounded-md text-sm flex items-center gap-2 hover:bg-blue-700">
              Mostrar dirección en el mapa
            </button>
          </div>

          <CollapsibleSection title="Ubicación en el mapa" sectionId="ubicacion">
            <p className="text-gray-300">Aquí se mostraría el mapa con la ubicación del cliente.</p>
          </CollapsibleSection>

          <CollapsibleSection title="Descuento" sectionId="descuento">
            <div className="form-group">
              <label htmlFor="descuento_porcentaje" className="block text-sm font-medium text-gray-300 mb-1">Descuento (%)</label>
              <input type="text" id="descuento_porcentaje" name="descuento_porcentaje" value={formData.descuento_porcentaje} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Datos bancarios" sectionId="datos_bancarios">
            <div className="form-group mb-4">
              <label htmlFor="iban" className="block text-sm font-medium text-gray-300 mb-1">IBAN</label>
              <input type="text" id="iban" name="iban" value={formData.iban} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
            </div>
            <div className="form-group">
              <label htmlFor="bic" className="block text-sm font-medium text-gray-300 mb-1">BIC/SWIFT</label>
              <input type="text" id="bic" name="bic" value={formData.bic} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Datos de contacto" sectionId="contacto">
            <div className="form-group mb-4">
              <label htmlFor="telefono" className="block text-sm font-medium text-gray-300 mb-1">Teléfono</label>
              <input type="tel" id="telefono" name="telefono" value={formData.telefono} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
            </div>
            <div className="form-group mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1">Email</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
            </div>
            <div className="form-group">
              <label htmlFor="web" className="block text-sm font-medium text-gray-300 mb-1">Página web</label>
              <input type="text" id="web" name="web" value={formData.web} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Idioma y formato numérico por defecto para facturas, presupuestos y albaranes" sectionId="idioma">
            <div className="form-row grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="form-col">
                <label htmlFor="idioma_select" className="block text-sm font-medium text-gray-300 mb-1">Idioma</label>
                <select id="idioma_select" name="idioma" value={formData.idioma} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500">
                  <option value="es">Español</option>
                  <option value="en">Inglés</option>
                  <option value="fr">Francés</option>
                </select>
              </div>
              <div className="form-col">
                <label htmlFor="formato_numerico" className="block text-sm font-medium text-gray-300 mb-1">Formato numérico</label>
                <select id="formato_numerico" name="formato_numerico" value={formData.formato_numerico} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500">
                  <option value="es">1.234,56</option>
                  <option value="en">1,234.56</option>
                </select>
              </div>
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Otros" sectionId="otros">
            <div className="form-group">
              <label htmlFor="notas" className="block text-sm font-medium text-gray-300 mb-1">Notas</label>
              <textarea id="notas" name="notas" rows="4" value={formData.notas} onChange={handleChange} className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500" placeholder="Información adicional sobre el cliente..."></textarea>
            </div>
          </CollapsibleSection>

          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          <div className="form-actions flex justify-end gap-3 pt-4 border-t border-slate-700">
            <button type="button" onClick={onClose} className="btn btn-secondary bg-gray-600 text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-gray-700">Cerrar</button>
            <button type="submit" className="btn btn-primary bg-blue-600 text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-blue-700">Crear</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCrearCliente;
